import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  'top-10-secrets-to-succeeding-with-ai',
  'Top 10 Secrets to Succeeding with AI: Transform Your Business Today',
  `${UPLOADS}/2024/06/digitopia-top10ai-web-02-400x400.jpg`,
  {
    download: pdf('fa77127f-4375-4a8d-9127-60f2e66ea6b8-Top 10 Secrets to Succeeding with AI.pdf'),
    // Designed as its own written page on 2026-08-28, from five screenshots
    // of `digitopia.co/impact-labs/ebooks/top-10-secrets-to-succeeding-with-ai/`
    // — so the slug above is confirmed rather than derived, the card goes to
    // that page, and `prerender.tsx` skips generating this template over the
    // top of it.
    href: '/en/impact-labs/ebooks/top-10-secrets-to-succeeding-with-ai',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 12
